// Music Manager Utility
// This utility helps manage MP3 files from the music folder

export const getMusicFiles = () => {
  // This function will be used to dynamically load music files
  // For now, we'll use a context require to get all files from the music folder
  try {
    const musicContext = require.context('../assets/music', false, /\.(mp3|wav|ogg|flac)$/);
    const musicFiles = musicContext.keys().map(file => ({
      path: musicContext(file),
      name: file.replace('./', '').replace(/\.[^/.]+$/, ""),
      fullName: file.replace('./', '')
    }));
    return musicFiles;
  } catch (error) {
    console.log('No music files found or error loading music files');
    return [];
  }
};

export const getTrackDuration = (audioFile) => {
  return new Promise((resolve) => {
    const audio = new Audio(audioFile);
    audio.addEventListener('loadedmetadata', () => {
      const duration = audio.duration;
      const minutes = Math.floor(duration / 60);
      const seconds = Math.floor(duration % 60);
      resolve(`${minutes}:${seconds.toString().padStart(2, '0')}`);
    });
  });
};

// Default track list when no audio files are available
export const getDefaultTracks = () => {
  return [
    { id: 1, title: "Hakk Mimarim", artist: "Tahir Palali, Erkan Ogur", duration: "0:48", file: null },
    { id: 2, title: "Rahm Eyle Halime", artist: "Tahir Palali", duration: "0:43", file: null },
    { id: 3, title: "Pervaz", artist: "Tahir Palali", duration: "0:42", file: null },
    { id: 4, title: "Hublarin Sahi", artist: "Tahir Palali", duration: "0:38", file: null },
  ];
};